//vue
import Vue from 'vue';
import VueRouter from 'vue-router';
//base
import Login from '../views/Login.vue';
import Home from '../views/Home.vue';
//pop
import POP from '../views/pop/Index.vue';
import POPLista from '../views/pop/Lista.vue';
import POPForm from '../views/pop/Form.vue';
//viabilidade
import Viabilidade from '../views/viabilidade/Index.vue';
import ViabilidadeLista from '../views/viabilidade/Lista.vue';
import ViabilidadeForm from '../views/viabilidade/Form.vue';
import ViabilidadeOpen from '../views/viabilidade/Open.vue';
import ViabilidadeExternal from '../views/viabilidade/External.vue';
//dio
import DIO from '../views/dio/Index.vue';
import DIOLista from '../views/dio/Lista.vue';
import DIOForm from '../views/dio/Form.vue';
//dio
import DIOPorta from '../views/dio_porta/Index.vue';
import DIOPortaLista from '../views/dio_porta/Lista.vue';
import DIOPortaForm from '../views/dio_porta/Form.vue';
//cdo
import CDO from '../views/cdo/Index.vue';
import CDOLista from '../views/cdo/Lista.vue';
import CDOForm from '../views/cdo/Form.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: "/home"
  },
  {
    path: '/login',
    component: Login 
  },
  {
    path: '/home',
    component: Home
  },
  {
    path: '/pop',
    component: POP,
    children: [
      {
        path: "/",
        component: POPLista
      },
      {
        path: ":id",
        component: POPForm
      }
    ]
  },
  {
    path: '/viabilidade',
    component: Viabilidade,
    children: [
      {
        path: "/",
        component: ViabilidadeLista
      },
      {
        path: ":id",
        component: ViabilidadeForm
      },
      {
        path: "open/:id",
        component: ViabilidadeOpen
      },
      {
        path: "form/:operadora",
        component: ViabilidadeExternal
      }
    ]
  },
  {
    path: '/dio',
    component: DIO,
    children: [
      {
        path: "/",
        component: DIOLista
      },
      {
        path: ":id",
        component: DIOForm
      }
    ]
  },
  {
    path: '/dio_porta',
    component: DIOPorta,
    children: [
      {
        path: "dio/:id",
        component: DIOPortaLista
      },
      {
        path: ":id",
        component: DIOPortaForm
      }
    ]
  },
  {
    path: '/cdo',
    component: CDO,
    children: [
      {
        path: "/",
        component: CDOLista
      },
      {
        path: ":id",
        component: CDOForm
      }
    ]
  }
];

const router = new VueRouter({
  routes
});

export default router;